var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91852 5.70949C2.62135 5.30716 1.96503 5.53581 2.00146 6.02898L3.55702 15.25H20.443L21.9985 6.02898C22.035 5.53581 21.3786 5.30716 21.0815 5.70949L17.4714 8.80012C17.2509 8.9889 16.9165 8.95085 16.7441 8.71736L12.824 3.41009C12.4202 2.8633 11.5798 2.8633 11.176 3.41009L7.25588 8.71736C7.08342 8.95085 6.74903 8.9889 6.52853 8.80011L2.91852 5.70949Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3687 16.75H3.63129L3.75165 19.181C3.82735 20.2059 4.70926 21 5.77183 21H18.2282C19.2907 21 20.1727 20.2059 20.2484 19.181L20.3687 16.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownAlt4);
export default __webpack_public_path__ + "static/media/crown-alt-4.793fc53e7896c38d6181ba6847358f3b.svg";
export { ForwardRef as ReactComponent };